import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const JiraIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 256 256">
    <path
      d="M244.658 0H121.707a55.502 55.502 0 0 0 55.502 55.502h22.649V77.37c.02 30.625 24.841 55.447 55.466 55.467V10.666C255.324 4.777 250.547 0 244.658 0Z"
      fill="#2684FF"
    />
    <path
      d="M183.822 61.262H60.872c.019 30.625 24.84 55.447 55.466 55.467h22.649v21.938c.039 30.625 24.877 55.428 55.502 55.428V71.928c0-5.889-4.776-10.666-10.665-10.666Z"
      fill="url(#jira_linear_1)"
    />
    <path
      d="M122.951 122.489H0c0 30.653 24.85 55.502 55.502 55.502h22.649v21.867c.02 30.625 24.841 55.447 55.466 55.467V133.155c0-5.889-4.776-10.666-10.665-10.666Z"
      fill="url(#jira_linear_2)"
    />
    <defs>
      <linearGradient id="jira_linear_1" x1="189.089" y1="61.262" x2="123.897" y2="127.558" gradientUnits="userSpaceOnUse">
        <stop offset="0.18" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
      <linearGradient id="jira_linear_2" x1="128.325" y1="122.489" x2="63.025" y2="187.789" gradientUnits="userSpaceOnUse">
        <stop offset="0.18" stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export default JiraIcon;